goog.provide("shadow.js.shim.module$spark_md5");
goog.provide("module$shadow_js_shim_module$spark_md5");
shadow.js.shim.module$spark_md5 = shadow.js.nativeProvides["spark-md5"] = shadow$bridge("spark-md5");
module$shadow_js_shim_module$spark_md5.default = shadow.js.shim.module$spark_md5;
